import { Root } from '@radix-ui/react-popover'
import type { ComponentPropsWithoutRef } from 'react'

export type PopoverProps = ComponentPropsWithoutRef<typeof Root>

export const Popover = (props: PopoverProps) => {
  return <Root modal {...props} />
}
